// Bridge the legacy context defined in MultipleStepsForm
// into a modern one using a React context provider so that the
// context can be used in modern React hook components.
import { createContext } from 'react'

const CheckoutContext = createContext({
  startLoading: () => {},
  stopLoading: () => {},
  pushComponent: () => {},
  goPrevious: () => {},
  handleValidationSuccessful: () => {},
  currentStep: () => {}
})

export default CheckoutContext
